import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 w-full" }
const _hoisted_2 = { class: "mb-10 mt-8 lg:mt-16 w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-5 mt-0" }, "Wywiad medyczny", -1)
const _hoisted_4 = { class: "mt-8 mb-3 lg:mb-0" }

import { ref, computed } from 'vue';
import VariationsField from '../shared/Fields/VariationsField.vue';
import ProductForm from '../shared/ProductForm.vue';
import { formSchema } from './schema';
import { initialValues } from './initialValues';
import IsPregnatField from '../shared/Fields/IsPregnatField.vue';
import PatientData from '../shared/PatientData.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import AdditionalDiseasesField from '../shared/Fields/AdditionalDiseasesField.vue';
import HasOperationsField from '../shared/Fields/HasOperationsField.vue';
import DrugWasField from '../shared/Fields/DrugWasField.vue';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import HasPermamentMedicationsField from '../shared/Fields/HasPermamentMedicationsField.vue';
import Terms from '../shared/Terms.vue';
import PrescriptionChoice from '../shared/Fields/PrescriptionChoice.vue';
import MedicationChoose from '../shared/MedicationChoose/MedicationChoose.vue';


export default {
  __name: 'Erecepta',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
    shortdescription: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    customer: {
        type: String,
        required: false,
    },
    variations: {
        type: String,
        required: false,
    },
    variantname: {
        type: String,
        required: false,
    },
},
  setup(__props) {

const props = __props;



const customerData = JSON.parse(props.customer || '{}');

const variationsData = JSON.parse(props.variations || []);
const selectedVariation = ref(variationsData[0]?.variation_id);

const selectVariation = (variationId) => {
    selectedVariation.value = variationId;
};

const values = computed(() => initialValues(customerData));

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(formSchema),
    initialValues: _unref(values),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price,
    title: __props.title,
    variations: _unref(variationsData),
    selectedVariation: selectedVariation.value,
    shortDescription: __props.shortdescription
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrescriptionChoice),
        _createVNode(MedicationChoose)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(IsPregnatField),
        _createVNode(AdditionalDiseasesField, {
          isExtended: true,
          title: "Czy występują u Pana(i) obciążenia chorobowe (np. cukrzyca)?"
        }),
        _createVNode(HasOperationsField, { isExtended: true }),
        _createVNode(HasPermamentMedicationsField),
        _createVNode(DrugWasField),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ImportantInformationField)
        ]),
        _createVNode(UploadedFileField)
      ]),
      _createVNode(PatientData),
      _createVNode(VariationsField, {
        name: __props.variantname,
        variations: _unref(variationsData),
        selectedVariation: selectedVariation.value,
        selectVariation: selectVariation,
        price: __props.price
      }, null, 8, ["name", "variations", "selectedVariation", "price"]),
      _createVNode(Terms)
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price", "title", "variations", "selectedVariation", "shortDescription"]))
}
}

}